import { render, staticRenderFns } from "./MatColorAdder.vue?vue&type=template&id=c6fc94be&scoped=true&"
import script from "./MatColorAdder.vue?vue&type=script&lang=js&"
export * from "./MatColorAdder.vue?vue&type=script&lang=js&"
import style0 from "./MatColorAdder.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./MatColorAdder.vue?vue&type=style&index=1&id=c6fc94be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fc94be",
  null
  
)

export default component.exports